import { useEffect, useState } from "react";
import { Button } from "../../Button";
import _ from "lodash";
import { tMsg } from "../../ToastNotifications";
import { IBaseInputProps } from "../Inputs";
import { pause } from "../../../utils";
import { fieldId } from "../utils";

export const TextInputForStringArray = ({
  addValueFunction,
}: {
  addValueFunction: (val: string) => void;
}) => {
  const [inputVal, setInputVal] = useState<string>("");
  const modifyInput = (val: string) => {
    if (val.includes('"'))
      tMsg.warning('Cannot include double quotes " for this field');
    else setInputVal(val);
  };
  return (
    <div className="flex gap-3">
      <input
        value={inputVal}
        className="w-full border border-[#ccc] p-2.5 text-sm"
        placeholder="Type to add..."
        onChange={(e) => {
          e.preventDefault();
          modifyInput(e.target.value);
        }}
      />
      <Button
        onClick={(e) => {
          e.preventDefault();
          const temp = inputVal;
          addValueFunction(temp);
          setInputVal("");
        }}
        disabled={inputVal.length < 1}
      >
        Add
      </Button>
    </div>
  );
};

export const StringArrayItem = ({
  name,
  ...restProps
}: React.ButtonHTMLAttributes<HTMLButtonElement> & { name: string }) => {
  return (
    <div className="flex gap-[1px] w-full">
      <div className="grid content-center w-full bg-grayBg px-3 py-0.5 text-sm">
        {name}
      </div>
      <button
        {...restProps}
        className="bg-grayBg px-2 py-0.5 text-white hover:bg-darkGrayBg"
      >
        <i className="icon-close text-xs" />
      </button>
    </div>
  );
};

export const BaseStringArray = (
  props: IBaseInputProps & {
    hideRemoveAll?: boolean;
    onRemoveValue?: (e: string) => void;
  }
): JSX.Element => {
  const { name, onChange, value, hideRemoveAll, onRemoveValue } = props;
  const [hasCheckedQuotes, setHasCheckedQuotes] = useState<boolean>(false);

  useEffect(() => {
    removeQuotes();
  }, []);

  const removeQuotes = async () => {
    try {
      if (value && _.isArray(value)) {
        const checkForQuotes = value.map((v) => v.replaceAll('"', ""));
        onChange({ target: { value: checkForQuotes } });
        await pause(100);
      }
    } finally {
      setHasCheckedQuotes(true);
    }
  };

  const curValue = (_.isArray(value) && value) || [];

  const addValueToList = (val: string) => {
    const valueToAdd = [...curValue, val];
    onChange({ target: { value: valueToAdd } });
  };

  const removeValueFromList = (indexToRemove: number) => {
    if (onRemoveValue) {
      const removedValue = curValue.find((v, index) => index === indexToRemove);
      onRemoveValue(removedValue);
    }
    const newList = curValue.filter((a, index) => index !== indexToRemove);
    onChange({ target: { value: newList } });
  };

  const removeAllDonors = () => {
    onChange({ target: { value: [] } });
  };

  return (
    <div id={fieldId(name)} className="space-y-4 pb-4">
      <TextInputForStringArray addValueFunction={addValueToList} />
      <div className="grid grid-cols-3 gap-3">
        {hasCheckedQuotes &&
          curValue.map((donor, index) => (
            <StringArrayItem
              name={donor}
              key={index}
              onClick={(e) => {
                e.preventDefault();
                removeValueFromList(index);
              }}
            />
          ))}
      </div>
      <div className="text-sm text-grayText my-2 font-medium">
        {curValue.length > 0 ? (
          <>
            <div>Total items: {curValue.length}</div>
            {hideRemoveAll || (
              <button
                onClick={(e) => {
                  e.preventDefault();
                  removeAllDonors();
                }}
                className="text-sm underline text-darkGrayBg hover:text-grayText"
              >
                Remove All
              </button>
            )}
          </>
        ) : (
          "No items - use the input above to add a tag"
        )}
      </div>
    </div>
  );
};
